import { Fragment } from 'react'

import Flex from 'styled-flex-component'

import CampaignBudget from '@components/Campaign/Budget/Budget'
import InboxTopPanelDeclinedFilters from '@components/Inbox/TopPanel/Declined/Filters'
import InboxViewOptions from '@components/Inbox/ViewOptions/ViewOptions'
import { SubmissionSortInfluencerList, SubmissionSortTiles } from '@components/Submission/Sort'
import { SubmissionStatuses } from '@enums'
import hooks from '@hooks'
import { Container } from '@tribegroup'
import InboxTopPanelMetrics from './Metrics/Metrics'

const metricsSupportedFilters: ReadonlyArray<any> = ['shortlisted', 'published']

const InboxTopPanel = () => {
  const { currentFilter } = hooks.useInboxFilter()
  const isInfluencerView = hooks.useIsInfluencerView()
  const {
    hasFilteredDeclinedLink,
    displayCampaignBudget,
    isSocialCampaign,
    isUnlockedCampaign,
  } = hooks.useInboxTopPanelData()
  const shouldDisplayMetrics = metricsSupportedFilters.includes(currentFilter)
  const isDeclinedListFilter = currentFilter === SubmissionStatuses.Declined
  const showDeclinedFilters = hasFilteredDeclinedLink && isDeclinedListFilter

  return (
    <Fragment>
      <Container bottomOuterSpacing={0.75}>
        <Flex alignCenter justifyBetween alignEnd>
          {isSocialCampaign && <InboxViewOptions />}
          {isInfluencerView ? <SubmissionSortInfluencerList /> : <SubmissionSortTiles />}
        </Flex>
      </Container>
      {displayCampaignBudget && <CampaignBudget />}
      {shouldDisplayMetrics && <InboxTopPanelMetrics />}
      {showDeclinedFilters && !isUnlockedCampaign && <InboxTopPanelDeclinedFilters />}
    </Fragment>
  )
}

export default InboxTopPanel
